import React, { useEffect, useState } from 'react'
import { Box, GridItem, Text } from '@chakra-ui/react'
import { useFeaturedProductsQuery } from '@lib/hooks/use-layout-data'
import { ITEMS_PER_PAGE, PRODUCT_LIMIT } from '@constants/product.constant'
import { ProductCategory, ProductCollection } from '@medusajs/medusa'
import PaginationLayout from '@layouts/pagination-layout'
import ProductCardItem from '@components/product/product-card-item'
import { ProductPreviewType } from 'types/global'

interface SuggestedProductsPropsType {
  categories: ProductCategory[]
  collections: ProductCollection[]
  productId: string
}

const SuggestedProducts = ({
  categories,
  collections,
  productId
}: SuggestedProductsPropsType) => {
  const [suggestedProducts, setSuggestedProducts] = useState<
    ProductPreviewType[]
  >([])

  const { data: productsCat, isLoading } = useFeaturedProductsQuery({
    limit: 10,
    offset: 0,
    category_id: categories.map((c) => c.id)
  })

  const { data: productsColl, isLoading: loading } = useFeaturedProductsQuery({
    limit: 10,
    offset: 0,
    collection_id: collections.map((c) => c.id)
  })

  useEffect(() => {
    if (productsCat != null && productsColl != null) {
      if (productsCat.products.length > PRODUCT_LIMIT) {
        const suggested_products = productsCat.products
          .filter((p) => p.id !== productId)
          .slice(0, 4)
        setSuggestedProducts([...suggested_products])
      } else {
        const suggested_products_cat = productsCat.products.filter(
          (p) => p.id !== productId
        )
        const suggested_products_coll = productsColl.products.filter(
          (p) => p.id !== productId
        )
        if (suggested_products_cat.length === PRODUCT_LIMIT) {
          setSuggestedProducts([...suggested_products_cat])
        } else {
          setSuggestedProducts([
            ...suggested_products_cat,
            ...suggested_products_coll.slice(
              0,
              PRODUCT_LIMIT - suggested_products_cat.length
            )
          ])
        }
      }
    }
  }, [productsCat, productsColl])

  return (
    <Box>
      <Text textStyle="sectionHeader" textAlign="center" mt={10} mb={12}>
        Suggested Products
      </Text>
      <PaginationLayout
        data={suggestedProducts ?? []}
        isLoading={isLoading || loading}
        itemsPerPage={ITEMS_PER_PAGE}
        skipPagination={false}
        renderItem={(item: any) => {
          return <ProductCardItem item={item} key={item.id} />
        }}
      />
    </Box>
  )
}

export default SuggestedProducts
